var map = {
	"./about.ar.mdx": 71469,
	"./about.de.mdx": 51352,
	"./about.en.mdx": 61662,
	"./about.es.mdx": 43677,
	"./about.fr.mdx": 9701,
	"./about.ru.mdx": 2351,
	"./about.zh.mdx": 5028,
	"./articles/access.ar.mdx": 32411,
	"./articles/access.de.mdx": 49511,
	"./articles/access.en.mdx": 85661,
	"./articles/access.es.mdx": 83044,
	"./articles/access.fr.mdx": 28708,
	"./articles/access.ru.mdx": 79466,
	"./articles/access.zh.mdx": 83058,
	"./articles/equity.ar.mdx": 60896,
	"./articles/equity.de.mdx": 85543,
	"./articles/equity.en.mdx": 72118,
	"./articles/equity.es.mdx": 37825,
	"./articles/equity.fr.mdx": 45364,
	"./articles/equity.ru.mdx": 39732,
	"./articles/equity.zh.mdx": 88129,
	"./articles/finance-aid.ar.mdx": 41189,
	"./articles/finance-aid.de.mdx": 28740,
	"./articles/finance-aid.en.mdx": 8408,
	"./articles/finance-aid.es.mdx": 26171,
	"./articles/finance-aid.fr.mdx": 52997,
	"./articles/finance-aid.ru.mdx": 7063,
	"./articles/finance-aid.zh.mdx": 44561,
	"./articles/finance.ar.mdx": 86019,
	"./articles/finance.de.mdx": 91859,
	"./articles/finance.en.mdx": 52033,
	"./articles/finance.es.mdx": 25603,
	"./articles/finance.fr.mdx": 84000,
	"./articles/finance.ru.mdx": 34170,
	"./articles/finance.zh.mdx": 80806,
	"./articles/learning.ar.mdx": 26320,
	"./articles/learning.de.mdx": 80832,
	"./articles/learning.en.mdx": 57630,
	"./articles/learning.es.mdx": 75731,
	"./articles/learning.fr.mdx": 66610,
	"./articles/learning.ru.mdx": 58148,
	"./articles/learning.zh.mdx": 48957,
	"./articles/quality.ar.mdx": 67678,
	"./articles/quality.de.mdx": 8173,
	"./articles/quality.en.mdx": 30174,
	"./articles/quality.es.mdx": 5279,
	"./articles/quality.fr.mdx": 39445,
	"./articles/quality.ru.mdx": 78794,
	"./articles/quality.zh.mdx": 34730,
	"./articles/trajectories.ar.mdx": 89603,
	"./articles/trajectories.de.mdx": 56156,
	"./articles/trajectories.en.mdx": 60538,
	"./articles/trajectories.es.mdx": 27533,
	"./articles/trajectories.fr.mdx": 40894,
	"./articles/trajectories.ru.mdx": 47694,
	"./articles/trajectories.zh.mdx": 27373,
	"./focus-articles.ar.mdx": 41024,
	"./focus-articles.de.mdx": 66635,
	"./focus-articles.en.mdx": 19218,
	"./focus-articles.es.mdx": 64917,
	"./focus-articles.fr.mdx": 60146,
	"./focus-articles.ru.mdx": 61026,
	"./focus-articles.zh.mdx": 28011,
	"./focus/0-template.ar.mdx": 42374,
	"./focus/0-template.de.mdx": 85890,
	"./focus/0-template.en.mdx": 27223,
	"./focus/0-template.es.mdx": 41809,
	"./focus/0-template.fr.mdx": 63714,
	"./focus/0-template.ru.mdx": 36283,
	"./focus/0-template.zh.mdx": 14006,
	"./focus/1-demand.ar.mdx": 67576,
	"./focus/1-demand.de.mdx": 88579,
	"./focus/1-demand.en.mdx": 38518,
	"./focus/1-demand.es.mdx": 33366,
	"./focus/1-demand.fr.mdx": 30268,
	"./focus/1-demand.ru.mdx": 285,
	"./focus/1-demand.zh.mdx": 39696,
	"./focus/10-earlyentry.ar.mdx": 91026,
	"./focus/10-earlyentry.de.mdx": 13587,
	"./focus/10-earlyentry.en.mdx": 65562,
	"./focus/10-earlyentry.es.mdx": 42616,
	"./focus/10-earlyentry.fr.mdx": 27944,
	"./focus/10-earlyentry.ru.mdx": 24168,
	"./focus/10-earlyentry.zh.mdx": 43536,
	"./focus/11-adulteducation.ar.mdx": 81339,
	"./focus/11-adulteducation.de.mdx": 62877,
	"./focus/11-adulteducation.en.mdx": 99155,
	"./focus/11-adulteducation.es.mdx": 88022,
	"./focus/11-adulteducation.fr.mdx": 13697,
	"./focus/11-adulteducation.ru.mdx": 52372,
	"./focus/11-adulteducation.zh.mdx": 63527,
	"./focus/12-lowperformance.ar.mdx": 18483,
	"./focus/12-lowperformance.de.mdx": 70676,
	"./focus/12-lowperformance.en.mdx": 85626,
	"./focus/12-lowperformance.es.mdx": 70745,
	"./focus/12-lowperformance.fr.mdx": 85508,
	"./focus/12-lowperformance.ru.mdx": 91021,
	"./focus/12-lowperformance.zh.mdx": 45464,
	"./focus/13-Spending.ar.mdx": 26021,
	"./focus/13-Spending.de.mdx": 91357,
	"./focus/13-Spending.en.mdx": 2370,
	"./focus/13-Spending.es.mdx": 64950,
	"./focus/13-Spending.fr.mdx": 36966,
	"./focus/13-Spending.ru.mdx": 95072,
	"./focus/13-Spending.zh.mdx": 4615,
	"./focus/14-householdwealth.ar.mdx": 62879,
	"./focus/14-householdwealth.de.mdx": 45737,
	"./focus/14-householdwealth.en.mdx": 3122,
	"./focus/14-householdwealth.es.mdx": 45105,
	"./focus/14-householdwealth.fr.mdx": 66113,
	"./focus/14-householdwealth.ru.mdx": 87847,
	"./focus/14-householdwealth.zh.mdx": 96708,
	"./focus/15-taxrevenue.ar.mdx": 69722,
	"./focus/15-taxrevenue.de.mdx": 3903,
	"./focus/15-taxrevenue.en.mdx": 16849,
	"./focus/15-taxrevenue.es.mdx": 92934,
	"./focus/15-taxrevenue.fr.mdx": 34081,
	"./focus/15-taxrevenue.ru.mdx": 87552,
	"./focus/15-taxrevenue.zh.mdx": 96506,
	"./focus/16-scholarships.ar.mdx": 7108,
	"./focus/16-scholarships.de.mdx": 95801,
	"./focus/16-scholarships.en.mdx": 64956,
	"./focus/16-scholarships.es.mdx": 54932,
	"./focus/16-scholarships.fr.mdx": 13923,
	"./focus/16-scholarships.ru.mdx": 8289,
	"./focus/16-scholarships.zh.mdx": 95461,
	"./focus/17-studentdebt.ar.mdx": 42827,
	"./focus/17-studentdebt.de.mdx": 40858,
	"./focus/17-studentdebt.en.mdx": 78952,
	"./focus/17-studentdebt.es.mdx": 91665,
	"./focus/17-studentdebt.fr.mdx": 8723,
	"./focus/17-studentdebt.ru.mdx": 356,
	"./focus/17-studentdebt.zh.mdx": 37060,
	"./focus/18-climatechange.ar.mdx": 74997,
	"./focus/18-climatechange.de.mdx": 97999,
	"./focus/18-climatechange.en.mdx": 18180,
	"./focus/18-climatechange.es.mdx": 21941,
	"./focus/18-climatechange.fr.mdx": 23745,
	"./focus/18-climatechange.ru.mdx": 16829,
	"./focus/18-climatechange.zh.mdx": 65210,
	"./focus/19-numeracyskills.ar.mdx": 10076,
	"./focus/19-numeracyskills.de.mdx": 12318,
	"./focus/19-numeracyskills.en.mdx": 64756,
	"./focus/19-numeracyskills.es.mdx": 23867,
	"./focus/19-numeracyskills.fr.mdx": 40615,
	"./focus/19-numeracyskills.ru.mdx": 29589,
	"./focus/19-numeracyskills.zh.mdx": 50043,
	"./focus/2-teachoutfield.ar.mdx": 66552,
	"./focus/2-teachoutfield.de.mdx": 44906,
	"./focus/2-teachoutfield.en.mdx": 19914,
	"./focus/2-teachoutfield.es.mdx": 9607,
	"./focus/2-teachoutfield.fr.mdx": 32930,
	"./focus/2-teachoutfield.ru.mdx": 61881,
	"./focus/2-teachoutfield.zh.mdx": 82493,
	"./focus/20-computationalthinking.ar.mdx": 63032,
	"./focus/20-computationalthinking.de.mdx": 22358,
	"./focus/20-computationalthinking.en.mdx": 9726,
	"./focus/20-computationalthinking.es.mdx": 28844,
	"./focus/20-computationalthinking.fr.mdx": 98257,
	"./focus/20-computationalthinking.ru.mdx": 78093,
	"./focus/20-computationalthinking.zh.mdx": 28847,
	"./focus/21-writingtools.ar.mdx": 99664,
	"./focus/21-writingtools.de.mdx": 94029,
	"./focus/21-writingtools.en.mdx": 99976,
	"./focus/21-writingtools.es.mdx": 36081,
	"./focus/21-writingtools.fr.mdx": 88642,
	"./focus/21-writingtools.ru.mdx": 73929,
	"./focus/21-writingtools.zh.mdx": 88530,
	"./focus/22-microdredentials.ar.mdx": 34427,
	"./focus/22-microdredentials.de.mdx": 42569,
	"./focus/22-microdredentials.en.mdx": 71378,
	"./focus/22-microdredentials.es.mdx": 8679,
	"./focus/22-microdredentials.fr.mdx": 68497,
	"./focus/22-microdredentials.ru.mdx": 62368,
	"./focus/22-microdredentials.zh.mdx": 26412,
	"./focus/23-firstgeneration.ar.mdx": 94606,
	"./focus/23-firstgeneration.de.mdx": 51985,
	"./focus/23-firstgeneration.en.mdx": 16876,
	"./focus/23-firstgeneration.es.mdx": 13428,
	"./focus/23-firstgeneration.fr.mdx": 66926,
	"./focus/23-firstgeneration.ru.mdx": 45187,
	"./focus/23-firstgeneration.zh.mdx": 98516,
	"./focus/24-readingspeed.ar.mdx": 35187,
	"./focus/24-readingspeed.de.mdx": 21013,
	"./focus/24-readingspeed.en.mdx": 23841,
	"./focus/24-readingspeed.es.mdx": 44798,
	"./focus/24-readingspeed.fr.mdx": 1629,
	"./focus/24-readingspeed.ru.mdx": 61445,
	"./focus/24-readingspeed.zh.mdx": 99617,
	"./focus/25-schoolbuilding.ar.mdx": 53061,
	"./focus/25-schoolbuilding.de.mdx": 71726,
	"./focus/25-schoolbuilding.en.mdx": 55949,
	"./focus/25-schoolbuilding.es.mdx": 46531,
	"./focus/25-schoolbuilding.fr.mdx": 36014,
	"./focus/25-schoolbuilding.ru.mdx": 74584,
	"./focus/25-schoolbuilding.zh.mdx": 54753,
	"./focus/26-solarenergy.ar.mdx": 93126,
	"./focus/26-solarenergy.de.mdx": 15950,
	"./focus/26-solarenergy.en.mdx": 65989,
	"./focus/26-solarenergy.es.mdx": 46045,
	"./focus/26-solarenergy.fr.mdx": 66991,
	"./focus/26-solarenergy.ru.mdx": 61188,
	"./focus/26-solarenergy.zh.mdx": 38832,
	"./focus/27-onlinesearch.ar.mdx": 38435,
	"./focus/27-onlinesearch.de.mdx": 5874,
	"./focus/27-onlinesearch.en.mdx": 33836,
	"./focus/27-onlinesearch.es.mdx": 90705,
	"./focus/27-onlinesearch.fr.mdx": 47146,
	"./focus/27-onlinesearch.ru.mdx": 23577,
	"./focus/27-onlinesearch.zh.mdx": 16,
	"./focus/28-mathanxiety.ar.mdx": 98332,
	"./focus/28-mathanxiety.de.mdx": 96520,
	"./focus/28-mathanxiety.en.mdx": 70963,
	"./focus/28-mathanxiety.es.mdx": 45812,
	"./focus/28-mathanxiety.fr.mdx": 51883,
	"./focus/28-mathanxiety.ru.mdx": 8737,
	"./focus/28-mathanxiety.zh.mdx": 10428,
	"./focus/29-ecceleaders.ar.mdx": 87208,
	"./focus/29-ecceleaders.de.mdx": 62103,
	"./focus/29-ecceleaders.en.mdx": 85194,
	"./focus/29-ecceleaders.es.mdx": 44955,
	"./focus/29-ecceleaders.fr.mdx": 57645,
	"./focus/29-ecceleaders.ru.mdx": 3185,
	"./focus/29-ecceleaders.zh.mdx": 2453,
	"./focus/3-calendar.ar.mdx": 18852,
	"./focus/3-calendar.de.mdx": 24659,
	"./focus/3-calendar.en.mdx": 31664,
	"./focus/3-calendar.es.mdx": 44997,
	"./focus/3-calendar.fr.mdx": 22415,
	"./focus/3-calendar.ru.mdx": 3186,
	"./focus/3-calendar.zh.mdx": 78870,
	"./focus/30-teachleadership.ar.mdx": 31779,
	"./focus/30-teachleadership.de.mdx": 87675,
	"./focus/30-teachleadership.en.mdx": 21261,
	"./focus/30-teachleadership.es.mdx": 80632,
	"./focus/30-teachleadership.fr.mdx": 50403,
	"./focus/30-teachleadership.ru.mdx": 69850,
	"./focus/30-teachleadership.zh.mdx": 20673,
	"./focus/31-peereffects.ar.mdx": 99985,
	"./focus/31-peereffects.de.mdx": 75340,
	"./focus/31-peereffects.en.mdx": 4203,
	"./focus/31-peereffects.es.mdx": 60006,
	"./focus/31-peereffects.fr.mdx": 47136,
	"./focus/31-peereffects.ru.mdx": 36018,
	"./focus/31-peereffects.zh.mdx": 36907,
	"./focus/32-civicedu.ar.mdx": 72295,
	"./focus/32-civicedu.de.mdx": 44149,
	"./focus/32-civicedu.en.mdx": 72652,
	"./focus/32-civicedu.es.mdx": 1238,
	"./focus/32-civicedu.fr.mdx": 60261,
	"./focus/32-civicedu.ru.mdx": 26142,
	"./focus/32-civicedu.zh.mdx": 73433,
	"./focus/33-climateinfra.ar.mdx": 83501,
	"./focus/33-climateinfra.de.mdx": 26871,
	"./focus/33-climateinfra.en.mdx": 86801,
	"./focus/33-climateinfra.es.mdx": 19030,
	"./focus/33-climateinfra.fr.mdx": 65176,
	"./focus/33-climateinfra.ru.mdx": 43883,
	"./focus/33-climateinfra.zh.mdx": 55832,
	"./focus/34-NSAscholarships.ar.mdx": 98915,
	"./focus/34-NSAscholarships.de.mdx": 8944,
	"./focus/34-NSAscholarships.en.mdx": 81882,
	"./focus/34-NSAscholarships.es.mdx": 65397,
	"./focus/34-NSAscholarships.fr.mdx": 75571,
	"./focus/34-NSAscholarships.ru.mdx": 92896,
	"./focus/34-NSAscholarships.zh.mdx": 90744,
	"./focus/35-teachershortage.ar.mdx": 314,
	"./focus/35-teachershortage.de.mdx": 58586,
	"./focus/35-teachershortage.en.mdx": 76374,
	"./focus/35-teachershortage.es.mdx": 32984,
	"./focus/35-teachershortage.fr.mdx": 67076,
	"./focus/35-teachershortage.ru.mdx": 61138,
	"./focus/35-teachershortage.zh.mdx": 76304,
	"./focus/36-principalsalaries.ar.mdx": 84163,
	"./focus/36-principalsalaries.de.mdx": 15504,
	"./focus/36-principalsalaries.en.mdx": 17722,
	"./focus/36-principalsalaries.es.mdx": 4773,
	"./focus/36-principalsalaries.fr.mdx": 89297,
	"./focus/36-principalsalaries.ru.mdx": 38550,
	"./focus/36-principalsalaries.zh.mdx": 42378,
	"./focus/37-climatefin.ar.mdx": 22488,
	"./focus/37-climatefin.de.mdx": 29001,
	"./focus/37-climatefin.en.mdx": 45473,
	"./focus/37-climatefin.es.mdx": 76393,
	"./focus/37-climatefin.fr.mdx": 11754,
	"./focus/37-climatefin.ru.mdx": 14997,
	"./focus/37-climatefin.zh.mdx": 54434,
	"./focus/4-singlesexschools.ar.mdx": 1680,
	"./focus/4-singlesexschools.de.mdx": 20831,
	"./focus/4-singlesexschools.en.mdx": 39864,
	"./focus/4-singlesexschools.es.mdx": 32520,
	"./focus/4-singlesexschools.fr.mdx": 24542,
	"./focus/4-singlesexschools.ru.mdx": 75801,
	"./focus/4-singlesexschools.zh.mdx": 44594,
	"./focus/5-infrastructure.ar.mdx": 1759,
	"./focus/5-infrastructure.de.mdx": 92672,
	"./focus/5-infrastructure.en.mdx": 2722,
	"./focus/5-infrastructure.es.mdx": 50976,
	"./focus/5-infrastructure.fr.mdx": 63034,
	"./focus/5-infrastructure.ru.mdx": 75371,
	"./focus/5-infrastructure.zh.mdx": 71855,
	"./focus/6-learningnotlinear.ar.mdx": 8309,
	"./focus/6-learningnotlinear.de.mdx": 60236,
	"./focus/6-learningnotlinear.en.mdx": 4004,
	"./focus/6-learningnotlinear.es.mdx": 12346,
	"./focus/6-learningnotlinear.fr.mdx": 29562,
	"./focus/6-learningnotlinear.ru.mdx": 64565,
	"./focus/6-learningnotlinear.zh.mdx": 87016,
	"./focus/7-safeschools.ar.mdx": 15979,
	"./focus/7-safeschools.de.mdx": 9848,
	"./focus/7-safeschools.en.mdx": 54751,
	"./focus/7-safeschools.es.mdx": 2315,
	"./focus/7-safeschools.fr.mdx": 85550,
	"./focus/7-safeschools.ru.mdx": 51159,
	"./focus/7-safeschools.zh.mdx": 92070,
	"./focus/8-scholarshipsSSA.ar.mdx": 71476,
	"./focus/8-scholarshipsSSA.de.mdx": 86799,
	"./focus/8-scholarshipsSSA.en.mdx": 82128,
	"./focus/8-scholarshipsSSA.es.mdx": 52653,
	"./focus/8-scholarshipsSSA.fr.mdx": 8113,
	"./focus/8-scholarshipsSSA.ru.mdx": 72007,
	"./focus/8-scholarshipsSSA.zh.mdx": 18085,
	"./focus/9-indigenous.ar.mdx": 55591,
	"./focus/9-indigenous.de.mdx": 24534,
	"./focus/9-indigenous.en.mdx": 38238,
	"./focus/9-indigenous.es.mdx": 89757,
	"./focus/9-indigenous.fr.mdx": 8871,
	"./focus/9-indigenous.ru.mdx": 78283,
	"./focus/9-indigenous.zh.mdx": 83134,
	"./index.ar.mdx": 15125,
	"./index.de.mdx": 49814,
	"./index.en.mdx": 99034,
	"./index.es.mdx": 49096,
	"./index.fr.mdx": 75743,
	"./index.ru.mdx": 3768,
	"./index.zh.mdx": 96053,
	"./indicators.ar.mdx": 34067,
	"./indicators.de.mdx": 90538,
	"./indicators.en.mdx": 35673,
	"./indicators.es.mdx": 22062,
	"./indicators.fr.mdx": 35113,
	"./indicators.ru.mdx": 10429,
	"./indicators.zh.mdx": 19167,
	"./terms.ar.mdx": 61689,
	"./terms.de.mdx": 34362,
	"./terms.en.mdx": 28227,
	"./terms.es.mdx": 7769,
	"./terms.fr.mdx": 31472,
	"./terms.ru.mdx": 61806,
	"./terms.zh.mdx": 79235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92509;